import { ActionContext, ActionTree } from 'vuex'
import { IProductsResponse, IProductsState, IRootState } from '@/@types'
import {
  availablePlansHydratation,
  availableProductBundlesHydratation,
  extensionsHydratation,
  liveVirtualTrainingsHydratation,
  skillDiveHydratation,
  vouchersHydratation,
} from '@/helpers/hydratations'
import { fetchPassTypes, getAvailableProductBundles, getAvailableProducts } from '@/models/products'

import CONSTANTS from '@/constants'
import { actionErrorHandling } from '@/helpers'

const { PLANS, PLAN_STATES } = CONSTANTS

const actions: ActionTree<IProductsState, IRootState> = {
  fetchAvailableProducts: async (context: ActionContext<IProductsState, IRootState>) => {
    try {
      const { LEGACY, SKILL_DIVE_ANNUAL, SKILL_DIVE_PTA } = PLANS
      const couponStr = context.rootGetters['coupons/getCoupon']
      const products = await getAvailableProducts(couponStr)

      const {
        subscriptions,
        certification_vouchers,
        current_subscriptions,
        live_virtual_trainings,
        skill_dive,
        extensions,
      }: IProductsResponse = products
      if (skill_dive) {
        skillDiveHydratation(skill_dive)
      }
      let availablePlans = availablePlansHydratation(context, subscriptions, skill_dive)

      const userSubscriptions = Object.values(current_subscriptions)
        .map(sub => {
          if (sub.plan_code === LEGACY) {
            return
          }
          if ([SKILL_DIVE_PTA, SKILL_DIVE_ANNUAL].includes(sub?.plan_code || '')) {
            return
          }
          return sub
        })
        .filter(
          userSub =>
            userSub?.plan_code &&
            [PLAN_STATES.active, PLAN_STATES.pending, PLAN_STATES.cancelled].includes(userSub.state)
        )
      const usersActiveSubscriptionsPlanCodes = userSubscriptions?.filter(plan => {
        if (plan?.state === CONSTANTS.PLAN_STATES.active) {
          return plan?.plan_code
        }
      })
      const userHasSubscription = usersActiveSubscriptionsPlanCodes.length > 0

      vouchersHydratation(certification_vouchers)

      if (live_virtual_trainings) {
        liveVirtualTrainingsHydratation(live_virtual_trainings)
      }

      if (extensions && extensions.length > 0) {
        extensionsHydratation(extensions)
      }

      context.commit('AVAILABLE_CERTIFICATIONS_UPDATED', certification_vouchers || [])
      context.commit('AVAILABLE_LIVE_VIRTUAL_TRAININGS_UPDATED', live_virtual_trainings || [])
      context.commit('AVAILABLE_EXAM_EXTENSIONS_UPDATED', extensions || [])
      context.commit('subscriptions/USERS_CURRENT_SUBSCRIPTIONS_UPDATED', userSubscriptions || [], {
        root: true,
      })
      context.commit('subscriptions/USER_HAS_SUBSCRIPTION_UPDATED', userHasSubscription, {
        root: true,
      })

      if (!context.rootGetters['subscriptions/isPremiumPlusEnabledForUser']) {
        availablePlans = availablePlans.filter(plan => plan.merchant_id !== PLANS.PREMIUM_PLUS)
      }

      context.commit('AVAILABLE_PLANS_UPDATED', availablePlans)
    } catch (error) {
      actionErrorHandling(context, error)
      throw error
    }
  },
  getPassTypes: async (context: ActionContext<IProductsState, IRootState>) => {
    try {
      const passes = await fetchPassTypes()
      context.commit('PASS_TYPES_UPDATED', passes)
    } catch (error) {
      actionErrorHandling(context, error)
    }
  },
  fetchAvailableProductBundles: async (context: ActionContext<IProductsState, IRootState>) => {
    try {
      const availableProductBundles = await getAvailableProductBundles()
      availableProductBundlesHydratation(availableProductBundles)
      context.commit('AVAILABLE_PRODUCT_BUNDLES_UPDATED', availableProductBundles)
    } catch (error) {
      actionErrorHandling(context, error)
      throw error
    }
  },
}

export default actions
